import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { AppInitService } from '../services/app-init.service';
import { AuthenticationService } from '../services/authentication.service';

@Pipe({
  name: 'datetime'
})
export class CustomDateTimePipe extends DatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) locale?: string, public appInitService?: AppInitService, private authService?: AuthenticationService) {
    super(locale);
    console.log("****************Custom Date Time Pipe");
  }

  get getLocale(): any {
    return JSON.parse(localStorage.getItem('appLocale'));
  }

  transform(value: any, args?: any): any {
    let dateFormat = args ? args : this.getLocale.dateTimeFormat;
    return this.dateFormatFromLocal(value, dateFormat)
  }

  dateFormatFromLocal(value, type) {
    switch (type) {
      case 'long':
        return super.transform(value, this.getLocale.longDateTimeFormat)
      case 'short':
        return super.transform(value, this.getLocale.shortDateTimeFormat);
      case 'medium':
        return super.transform(value, this.getLocale.mediumDateTimeFormat);
      case 'full':
        return super.transform(value, this.getLocale.fullDateTimeFormat);
      default:
        return super.transform(value, type);
    }
  }

}
